import { useMemo } from 'react';

import {
  SetExpectedClassSize,
  SetExpectedClassSizeVariables,
} from 'approot/classes/__generated__/SetExpectedClassSize';
import { SET_EXPECTED_CLASS_SIZE } from 'approot/classes/classes.graphql';
import { useCurrentClassVar } from 'approot/classes/classes.hooks';
import { useSnackbar } from 'approot/shared/snackbar-notification/snackbar-notification.hooks';
import { useLoggingMutation } from 'lib/apollo/apollo-hooks';
import useUserData from 'approot/shared/user/user-data';

export const useSetExpectedClassSize = () => {
  const { user } = useUserData();

  const currentClass = useCurrentClassVar();
  const classId = currentClass?.id;

  const { showSuccess, showError } = useSnackbar();

  const expectedClassSize = useMemo(
    () => user?.userClasses?.find(uc => uc.id === classId)?.expectedClassSize,
    [classId, user?.userClasses]
  );

  const [setExpectedClassSize, { loading, error }] = useLoggingMutation<
    SetExpectedClassSize,
    SetExpectedClassSizeVariables
  >(SET_EXPECTED_CLASS_SIZE, {
    onCompleted: () => {
      showSuccess('All set! Your student count is saved.');
    },
    onError: () => {
      showError('Oops! Failed to save the student count. Please try again.');
    },
  });

  return {
    setExpectedClassSize,
    setExpectedClassSizeLoading: loading,
    expectedClassSize,
    classId,
    error,
  };
};
